import {
  Component,
  OnInit,
  Input,
  AfterViewInit,
  ViewChild,
  Output,
  EventEmitter,
  SimpleChange,
  SimpleChanges,
} from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import {
  ApexChart,
  ApexFill,
  ApexPlotOptions,
  ApexStroke,
  ApexNonAxisChartSeries,
  ApexLegend,
} from "ng-apexcharts";
import { PageEvent } from "@angular/material/paginator";
import { CitaService } from "../../../services/cita.service";
import { UserService } from "../../../services/user.service";
import { Router } from "@angular/router";
import { FolderService } from "../../../services/folder.service";
import swal from "sweetalert2";

@Component({
  selector: "app-card-widget",
  templateUrl: "./card-widget.component.html",
  styleUrls: ["./card-widget.component.css"],
  providers: [UserService],
})
export class CardWidgetComponent implements OnInit, AfterViewInit {
  // Table data and paginator
  @Output() filterChanged = new EventEmitter<
    "day" | "month" | "year" | "quarter"
  >();
  @Output() pageChange = new EventEmitter<PageEvent>();

  onPaginatorChange(event: PageEvent) {
    console.log("Evento del paginador:", event); // Asegúrate de que esto se imprime
    this.pageChange.emit(event);
  }
  @Input() title: string = "";
  @Input() backgroundColor: string = "#fff";
  @Input() borderColor: string = "#fff";
  @Input() swapTooltip: string = "Change to";
  @Input() lastUpdate: string = "";
  @Input() iconBtn: string = "more_vert";
  @Input() items_per_page: 0;
  @Input() page_actual: 0;
  @Input() total_items_count: 0;
  @Input() total_pages: 0;
  @Input() defaultLabel: string = ""; // Valor por defecto
  @Input() avatar: boolean = false;
  @Input() hasButtonSwap: boolean = false;
  @Input() notes: boolean = false;
  @Input() list: boolean = false;
  @Input() isMoney: boolean = true;
  @Input() hasCheckboxColumn: boolean = false;
  @Input() hasPercentage: boolean = false;
  @Input() pagination: boolean = false;
  @Input() qty: string = "";
  @Input() repId = "";
  @Input() data: any[] = []; // Array de datos para la tabla
  @Input() filters: any[] = []; // Array de datos para la tabla
  @Input() displayedColumns: { key: string; header: string }[] = []; //
  @Input() labelTime: "day" | "month" | "year" | "quarter" = "month";
  dataSource = new MatTableDataSource<any>();
  columnsKeys: string[] = [];
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  ngAfterViewInit() {
    this.paginator?.page.subscribe((event) => {
      console.log("Evento manual del paginador:", event);
    });
  }
  // Progress circle
  @Input() percentage: number = 75; // Default progress value
  public chartSeries: ApexNonAxisChartSeries = [this.percentage];
  public token;
  public identity;

  public chartDetails = {
    chart: {
      type: "radialBar",
    } as ApexChart,
    plotOptions: {
      radialBar: {
        hollow: {
          size: "50%", // Tamaño del hueco interior
          // imageWidth: 50,
          // imageHeight: 50,
        },
        dataLabels: {
          show: true,
          name: {
            show: false, // Oculta el título "series-1"
          },
          value: {
            fontSize: "16px",
            color: "#333", // Color del valor mostrado
            show: true,
            fontFamily: undefined,
            fontWeight: 400,
            offsetY: 5,
            formatter: (val: number) => `${val}%`, // Muestra el porcentaje
          },
        },
      },
    } as ApexPlotOptions,
    fill: {
      colors: ["#9C27B0"], // Color de la parte llena del círculo
    } as ApexFill,
    stroke: {
      lineCap: "round", // Bordes suaves
    } as ApexStroke,
    legend: {
      show: false, // Oculta la leyenda
    } as ApexLegend,
  };

  public note = "";
  public editNote = false;
  public avatars = [
    { name: "Anuar G." },
    { name: "Juan P." },
    { name: "Maria T." },
  ];
  constructor(
    private _citaService: CitaService,
    private _userService: UserService,
    private _fService: FolderService,
    private router: Router
  ) {
    this.token = this._userService.getToken();
    this.identity = this._userService.getIdentity();
    // console.log("identidad", this.identity);
  }

  ngOnInit(): void {
    if (this.notes) {
      console.log("my token", this.token);
      this.getNotes();
    }
    console.log("data", this.data);
    // Setup table data
    // this.dataSource.data = this.data;
    // this.columnsKeys = this.displayedColumns.map((col) => col.key);

    // Update progress dynamically if needed
    this.chartSeries = [this.percentage];
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data && this.data) {
      this.dataSource.data = this.data;
      this.columnsKeys = this.displayedColumns.map((col) => col.key);
    }
    if (changes["repId"]) {
      this.getNotes();
    }
  }

  openPi() {
    window.location.href = "/processing-instructions/4280";
  }

  get isPurchasingRep() {
    return (
      this.identity.sub == 22 || // Anuar
      this.identity.sub == 37 || // Ricardo
      this.identity.sub == 7971 || // Jona
      this.identity.sub == 84 || // Orlando
      // this.identity.sub == 4 // admin
      this.identity.role == "PURCHASINGREP"
    );
  }
  get isDashAdmin() {
    return (
      this.identity.sub == 22 || // Anuar
      this.identity.sub == 37 || // Ricardo
      this.identity.sub == 84 // Orlando
    );
  }

  filterLabels: Record<string, string> = {
    today: "Today",
    month: "This Month",
    week: "This Week",
    year: "This Year",
    lastYear: "Last Year",
    lastMonth: "Last Month",
    everything: "Everything",
    quarter: "This Quarter",
    "1_month": "Older Than 1 Month",
    "3_month": "Older Than 3 Months",
    "6_month": "Older Than 6 Months",
    "1_year": "Older Than 1 Year",
  };

  get fullName() {
    return (name: string, surname: string) => {
      const safeName = name ? name : ""; // Verifica si el nombre existe
      const safeSurname = surname ? surname : ""; // Verifica si el apellido existe
      return `${safeName} ${safeSurname ? surname.substring(0, 1) + "." : ""}`;
    };
  }
  get filteredData(): any[] {
    return this.displayedColumns.some((col) => col.key === "buyer")
      ? this.data.slice(3)
      : this.data;
  }
  get topThree(): any[] {
    return this.displayedColumns.some((col) => col.key === "buyer")
      ? this.data.slice(0, 3)
      : [];
  }
  get filteredColumnsKeys(): string[] {
    return this.columnsKeys.filter(
      (col) =>
        // Mostrar 'profit' en TODAS las tablas excepto en 'Top 10 Buyers' sin Admin
        col !== "profit" ||
        this.title !== "Top 10 Buyers" ||
        this.identity.role === "ADMINISTRATOR"
    );
  }
  getPo(poline, po, e) {
    e.stopPropagation();

    const currentPo = poline ? poline : po;
    this._fService.getPOid(this.token, currentPo).subscribe(
      (r) => {
        console.log("current po", currentPo);
        //console.log("response getPOid => ", r);
        if (r.code === 400 && r.msg === "Authorization not valid") {
          localStorage.clear();
          this.router.navigate(["/pages/lock"]);
        } else if (r.status === "success") {
          this.showToast("success", "Redirecting...", 6000);
          console.log("po id", r.data);
          window.open("/purchase-order/" + r.data.po.id, "_blank");
        } else if (r.code === 404) {
          this.showToast("error", "Oops, something went wrong", 6000);
          window.open("/purchase-order/", "_blank");

          // this.router.navigate(['/processing-instructions/' + 12345]);
        }
      },
      (error) => {}
    );
    // this.router.navigate(['/processing-instructions/' + po]);
  }

  getItem(item_id) {
    window.open("/inventory/product/" + item_id, "_blank");
  }
  showToast(type, title, timer) {
    const Toast = swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: timer,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = swal.stopTimer;
        toast.onmouseleave = swal.resumeTimer;
      },
    });
    Toast.fire({
      icon: type,
      title: title,
    });
  }

  getAvatarPosition(index: number) {
    if (index === 0) return "avatar-middle"; // Para la posición 1
    if (index === 1) return "avatar-start"; // Para la posición 2
    if (index === 2) return "avatar-end"; // Para la posición 3
  }

  getFilterLabel(filter: string): string {
    return this.filterLabels[filter] || filter; // Si no está en el mapa, deja el valor original
  }

  // ngAfterViewInit() {
  //   this.dataSource.paginator = this.paginator;
  // }
  formatLastUpdate(dateString: string): string {
    const date = new Date(dateString.replace(" ", "T")); // convierte a formato ISO

    const options: Intl.DateTimeFormatOptions = {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    };

    return date.toLocaleString("en-US", options);
  }

  onMoreClick(): void {
    console.log("More options clicked");
    if (this.notes) {
      this.editNotes();
    }
  }
  public noteId = null;
  editNotes() {
    if (this.iconBtn == "edit") {
      this.iconBtn = "save";
      this.editNote = true;
    } else {
      this.saveNote();
      this.iconBtn = "edit";
      this.editNote = false;
    }
  }

  saveNote() {
    const onSuccess = (response: any) => {
      if (response.status === "success") {
        console.log("se envió", response);
        // ✅ Esperamos hasta que se guarde para luego hacer getNotes
        this._citaService.getDashboardNotes(this.token).subscribe(
          (res) => {
            if (res.status === "success" && res.data.length > 0) {
              this.note = res.data[0].comment;
              this.noteId = res.data[0].id;
            }
            // ✅ Aquí actualizamos estado del botón
            this.iconBtn = "edit";
            this.editNote = false;
          },
          (error) => {
            console.log("error al obtener nota", error);
          }
        );
      } else {
        console.log("error en respuesta");
      }
    };

    const onError = (error: any) => {
      console.log("error", error);
    };

    if (!this.noteId) {
      this._citaService
        .createNote(this.token, this.note)
        .subscribe(onSuccess, onError);
    } else {
      this._citaService
        .editNote(this.token, this.note, this.noteId)
        .subscribe(onSuccess, onError);
    }
  }
  @Output() onButtonClick = new EventEmitter<void>();

  handleClick() {
    this.onButtonClick.emit(); // o puedes emitir algún valor si lo necesitas
  }
  removeNote() {
    this._citaService.removeNote(this.token, this.note, this.noteId).subscribe(
      (response) => {
        if (response.status == "success") {
          this.note = "";
          this.noteId = "";
          this.getNotes();
          console.log("se envió", response);
        } else {
          console.log("error");
        }
      },
      (error) => {
        console.log("error", error);
      }
    );
  }
  getNotes() {
    this._citaService.getDashboardNotes(this.token, this.repId).subscribe(
      (response) => {
        // este endpoint regresa un arreglo pero por ahora en esta versión sólo manejaremos una sola nota que se pueda ver, editar y borrar
        if (response.status == "success") {
          if (response.data.length > 0) {
            console.log(response.data[0].comment);
            this.note = response.data[0].comment;
            this.noteId = response.data[0].id;
            if (this.repId == this.identity.sub) {
              this.iconBtn = "edit";
            }
          } else {
            if (this.repId == this.identity.sub) {
              this.iconBtn = "save";
            }
          }

          if (!response.data.length) {
            this.note = "";
          }
        } else {
          console.log("error");
        }
      },
      (error) => {
        console.log("error", error);
      }
    );
  }
  onFilterChange(filterType): void {
    // this.labelTime = filterType;
    console.log(`Filtro seleccionado: ${filterType}`);
    this.filterChanged.emit(filterType);
    // Aquí puedes implementar la lógica para aplicar el filtro.
  }

  onCheckboxChange(id: any): void {
    console.log(`Checkbox clicked for:`, id);
    this._citaService.reminderStatus(this.token, id).subscribe(
      (response) => {
        if (response.status == "success") {
        } else {
          console.log("error");
        }
      },
      (error) => {
        console.log(<any>error);
      }
    );
    // Aquí puedes realizar acciones adicionales
  }
}
